// extracted by mini-css-extract-plugin
export default {"ValueDropdownOption":"ValueDropdownOption__ValueDropdownOption-r5VDN","DisplayValue":"ValueDropdownOption__DisplayValue-exRUP","Icon":"ValueDropdownOption__Icon-yMZOF"};